"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const Panel_1 = tslib_1.__importDefault(require("../Panel"));
const join_1 = tslib_1.__importDefault(require("../utils/join"));
const WizardPanel = (props) => {
    return (React.createElement(Panel_1.default, Object.assign({ border: "none", borderRadius: "none", variant: "primary", bodyScroll: true }, props, { className: (0, join_1.default)(props.className, 'ab-WizardPanel'), style: Object.assign({ height: '100%' }, props.style) })));
};
exports.default = WizardPanel;
